import { TimeUnit } from '@/types/enums'

const transformToSeconds = (value: number | string, unit?: string | TimeUnit): number => {
    // Replace comma with period if value is a string
    let normalizedValue = typeof value === 'string' ? value.replace(',', '.') : value.toString()
    let numericValue = parseFloat(normalizedValue)

    // Check if the conversion to number failed
    if (isNaN(numericValue)) {
        throw new Error('Invalid numeric value')
    }

    const calculateSeconds = (): number => {
        switch (unit) {
            case 'h': // Hours
                return numericValue * 60 * 60
            case 'm': // Minutes
                return numericValue * 60
            case 's': // Seconds
            default:
                return numericValue
        }
    }

    return Math.ceil(calculateSeconds())
}

const toDaysHoursMinutesSeconds = (totalSeconds: number) => {
    interface TimeUnit {
        length: number
        short: string
        long: string
    }
    const time: { seconds?: TimeUnit; minutes?: TimeUnit; hours?: TimeUnit; days?: TimeUnit } = {}

    time.seconds = {
        length: Math.floor(totalSeconds % 60),
        short: 's',
        long: 'second'
    }
    time.minutes = {
        length: Math.floor((totalSeconds % 3600) / 60),
        short: 'm',
        long: 'minute'
    }
    time.hours = {
        length: Math.floor((totalSeconds % (3600 * 24)) / 3600),
        short: 'h',
        long: 'hour'
    }
    time.days = {
        length: Math.floor(totalSeconds / (3600 * 24)),
        short: 'd',
        long: 'day'
    }

    const timeStringShort = []
    const timeStringLong = []
    for (const [, unit] of Object.entries(time).reverse()) {
        if (!unit.length) continue
        timeStringShort.push(`${unit.length}${unit.short}`)
        timeStringLong.push(`${unit.length} ${unit.long}${unit.length == 1 ? '' : 's'}`)
    }
    if (!timeStringShort.length) return '0 seconds'
    return timeStringShort.length > 1 ? timeStringShort.join(', ') : timeStringLong[0]
}

const timestampToDate = (value: number) => {
    if (!value) return value
    const options: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hourCycle: 'h23',
        hour: '2-digit',
        minute: '2-digit'
    }
    const dateTime = new Date(value * 1000)
    const formattedDateTime = new Intl.DateTimeFormat('en-US', options).format(dateTime)
    return formattedDateTime
}
const UTCTimeToDate = (value: string) => {
    if (!value) return value
    const options: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hourCycle: 'h23',
        hour: '2-digit',
        minute: '2-digit'
    }
    const dateTime = new Date(value)
    const formattedDateTime = new Intl.DateTimeFormat('en-US', options).format(dateTime)
    return formattedDateTime
}

export { transformToSeconds, toDaysHoursMinutesSeconds, timestampToDate, UTCTimeToDate }
